import {ColumnsConfigType} from "../types/table-data.types";

export const actionsWidths: Array<number> = [ 100, 70, 70, 70, 70 ];

export const statsWidths: Array<number> = [ 60, 60, 60, 60, 60 ];

export const resultsWidths: Array<number> = [ 80, 80 ];

export const columnsConfig: Array<ColumnsConfigType> = [
  {
    type: 'actions',
    columns: ['Просмотры', 'Клики', 'Переходы', 'Заказы', 'Запросы'],
    widths: actionsWidths,
    columnName: 'Действия',
    columnType: 'isActionsColumnOpen'
  },
  {
    type: 'stats',
    columns: ['CPV', 'CPC', 'CPA', 'CPS', 'CPZ'],
    widths: statsWidths,
    columnName: 'Статистика',
    columnType: 'isStatsColumnOpen'
  },
  {
    type: 'results',
    columns: ['Ср. чек', 'Интеграций'],
    widths: resultsWidths,
    columnName: 'Итоги',
    columnType: 'isResultsColumnOpen'
  },
];
